import axios from '@axios'


/**
 * ÍNDICE
 * 
 * {@link getGroups} - Obtener grupos
 * {@link getGroup} - Obtener grupo
 * {@link addGroup} - Añadir grupo 
 * {@link updateGroup} - Actualizar grupo 
 * {@link deleteGroup} - Eliminar grupo 
 * {@link addGroupSerie} - Asociar una serie a un grupo
 * {@link addGroupBankAccount} - Asociar una cuenta bancaria a un grupo 
 * 
 */



    /**
     * Obtener todas las sucursales
     * @param {*} data Datos para filtrar la consulta
     * @returns   | error
     */
    export const getGroups = function(queryParams)  {

        try {
            return new Promise((resolve, reject) => {
                axios
                    .get('/groups', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return error
        }
        }
    export const getGroup = function ( { id }) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/groups/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return error
        }
        }

    export const addGroup = function ( data) {

        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/groups`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/groups`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        }
            
        }
    export const deleteGroup = function ( { id }) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/groups/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return error
        }
        }

    export const updateGroup = function ( groupData) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/groups/${groupData.id}`, groupData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return error
        }
    }
    
    export const addGroupSerie = function (groupData) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/group-serie`, groupData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return error
        }
    }

    export const addGroupBankAccount = function (groupData) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/group-bank-account`, groupData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return error
        }
    }

    export const addDefaultSerie = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/default-serie`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return error
        }
    }

    export const addDefaultBankAccount= function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/default-bank-account`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return error
        }
    }
